import React from 'react'
import "../styles/index.scss"
import IssuesManagementPage from './IssuesManagementPage'

const ID_SUPPLIER_MCLap = "66dad3efcdd92285af643843"

const IssuesManagementContainer = () => {

    return (
        <div className='IssuesManagementContainer'>
            <IssuesManagementPage idSupplier={ID_SUPPLIER_MCLap} />
        </div>
    )
}

export default IssuesManagementContainer